const ProductItem = ({ product }) => (
    <a href="/#" className="product-item">
        <div className="product-item__image">
            <img src={product.img} alt={product.name} />
        </div>
        <div className="product-item__name">
            <p className="body2">{product.name}</p>
        </div>
    </a>
);

export default ProductItem;
